/**
 * How far back (in days) to sync emails during the initial sync.
 *
 * grep bait:
 *   initialSyncStartFromDaysAgo
 *   fromDaysAgo
 */
export const INITIAL_SYNC_NUM_DAYS_AGO = NutClientConfig.hasImprovedEmailCalendarSyncFF ? 90 : 30;
